import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { FiltresService } from '../../services/filtres/filtres.service';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { TexteModele } from 'src/app/utils/interfaces/new/TexteModele';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class TexteService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/personnalisation/';
  private apiHypermedUri = environment.basePath + '/hypermed/';

  constructor(
    private _http: HttpClient,
    private _filtresService: FiltresService,

    private _snack: SnackbarService
  ) { }

  async findTextesList(type: string, filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortBy: 'titre',
    sortOrder: SortEnum.ASC
  }): Promise<TexteModele[]> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this._http.get(this.apiUri + 'textes?type=' + type, this.httpOptions).toPromise();
      const refs = res.body as TexteModele[];
      return refs;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async findOneTexte(idTexte: string): Promise<TexteModele> {
    try {
      const res = await this._http.get(this.apiUri + 'textes/' + idTexte, this.httpOptions).toPromise();
      const refs = res.body as TexteModele;
      return refs;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

 async findTextesCabinet(type: string): Promise<TexteModele[]> {
    try {
      const res = await this._http.get(this.apiUri + 'textes/cabinet?type=' + type, this.httpOptions).toPromise();
      const refs = res.body as TexteModele[];
      return refs;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  /**
   * cette fonction n'est plus utilisée actuellement, mais elle permettra la récupération des textes hypermed dans le futur
   */
  async findTextesHypermed(type: string): Promise<TexteModele[]> {
    try {
      const res = await this._http.get(this.apiHypermedUri + 'textes?type=' + type, this.httpOptions).toPromise();
      const refs = res.body as TexteModele[];
      return refs;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async addTexteToUser(texte: TexteModele) {
    try {
      return await this._http.post(this.apiUri + 'textes', texte, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async syncTextesToUser(type: string) {
    try {
      return await this._http.post(this.apiUri + 'textes/sync?type=' + type, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async syncTexteOneToUser(idTexte: string) {
    try {
      return await this._http.post(this.apiUri + 'textes/' + idTexte + '/sync', this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async updateTexteOneToUser(texte: TexteModele) {
    try {
      return await this._http.put(this.apiUri + 'textes/' + texte.id, texte, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async deleteTexteOneToUser(idTexte: string) {
    try {
      return await this._http.delete(this.apiUri + 'textes/' + idTexte, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
